<template>
  <div>
    <ElHeader class="el-header">
      <div class="logo-container">
        <img
          src="../assets/main-logo-white.png"
          height="319"
          width="927"
          alt="raas-logo"
          class="logo"
        />
      </div>
    </ElHeader>
    <ElMain>
      <RouterView />
    </ElMain>
  </div>
</template>

<style scoped>
.el-header {
  background: linear-gradient(to top right, #99ccff, var(--tertiary-color));
  @apply border-b-2;
}

.logo-container {
  @apply h-full flex items-center;
}

.logo {
  @apply h-full;
  width: auto; /* maintain aspect ratio */
}
</style>
